import React from "react";

const Landing = (props) => {
  return (
		<div className="frame">
		<div className="note-1">
        	<p className="note">~~ ~~ ~~~~ ~</p>
		</div>
		<div className="note-2">
			<p className="note">~~~~~ ~~~ ~~ ~ ~</p>
		</div>

		<div className="desk">
			<div className="desk-top-1"></div>
			<div className="desk-top-2"></div>
			<div className="desk-top-3">
			<div className="desk-top-3-right"></div>
		</div>
		<div className="desk-leg-right"></div>
		<div className="desk-leg-left"></div>
		</div>

		<div className="mug"></div>

		<svg
			className="steam-svg"
			viewBox="0 0 378 482"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
		<g
			id="steam"
          transform="translate(40.000000, 0.000000)"
          stroke="#B9E0DD"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M157.987687,257.503906 C163.009234,237.681133 168.393126,224.436028 166.905656,201.929376 C165.924107,187.077744 160.361805,174.336252 154.69055,161.809345 C145.186824,135.469476 141.691007,126.092005 142.656837,110.157402 C144.172525,85.1510409 162.510355,68.5942315 158.615668,42.4358288 C157.497371,34.9248651 155.311625,28.1452763 153.659604,21"
            id="steam-5"
            className="steam"
            strokeDasharray="10,42,12"
          ></path>
          <path
            d="M79.4980631,257.503906 C84.5196101,237.681133 89.9035021,224.436028 88.4160318,201.929376 C87.4344837,187.077744 81.8721808,174.336252 76.200926,161.809345 C66.6972003,135.469476 63.2013835,126.092005 64.1672133,110.157402 C65.6829015,85.1510409 84.0207308,68.5942315 80.126044,42.4358288 C79.0077475,34.9248651 76.8220013,28.1452763 75.1699799,21"
            id="steam-3"
            className="steam"
            strokeDasharray="64,22,12"
          ></path>
          <path
            d="M118.742875,258.503906 C123.764422,236.837184 129.148314,222.359997 127.660844,197.759737 C126.679296,181.526581 121.116993,167.599854 115.445738,153.907673 C105.942012,125.117624 102.446195,114.867844 103.412025,97.4509767 C104.927713,70.1184811 123.265543,52.0215287 119.370856,23.4298264 C118.252559,15.22018 116.066813,7.80994215 114.414792,0"
            id="steam-4"
            className="steam"
            strokeDasharray="44,22,12"
          ></path>
        </g>
      </svg>

      <div className="computer">
        <div className="computer-side">
          <div className="computer-back"></div>
        </div>
        <div className="computer-stand">
          <div className="computer-stand-shadow"></div>
          <div className="computer-stand-hole"></div>
          <div className="computer-cable"></div>
        </div>
        <div className="computer-stand-bottom"></div>
        <div className="computer-stand-curve"></div>
      </div>

      <div className="book-stack">
        <div className="book-1"></div>
        <div className="book-2"></div>
        <div className="book-3"></div>
        <div className="book-4"></div>
        <div className="book-5"></div>
        <div className="book-6"></div>
      </div>

      <div className="chair">
        <div className="chair-seat">
          <div className="chair-arm-left"></div>
          <div className="chair-back"></div>
          <div className="chair-spine"></div>
          <div className="chair-pole">
            <div className="chair-rod"></div>
          </div>
          <div className="chair-arm-right"></div>
          <div className="chair-legs">
            <div className="chair-leg-left">
              <div className="left-wheel"></div>
            </div>
            <div className="chair-leg-middle">
              <div className="middle-wheel"></div>
            </div>
            <div className="chair-leg-right">
              <div className="right-wheel"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="floor"></div>

      <div className="floor-binder">
        <div className="floor-binder-1"></div>
        <div className="floor-binder-2"></div>
      </div>

      <div className="bag">
        <div className="bag-body">
          <div className="bag-handle-front"></div>
          <div className="bag-handle-back"></div>
          <div className="bag-side"></div>
        </div>
      </div>

      <div className="big-box">
        <div className="big-box-body">
          <div className="big-box-shadow"></div>
          <div className="big-box-hole"></div>
        </div>
        <div className="box-folder"></div>
        <div className="folder-paper"></div>
      </div>
    </div>
  );
};

export default Landing;
